import React, { useEffect,  useState} from 'react';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  Button,
  Input,
  InputLabelWrapper
} from '../../../platform/ui/src/components';

import { LoadingIndicatorProgress } from '@ohif/ui';
import { DicomMetadataStore } from '@ohif/core';
import downloadBlob from '../../utils/downloadBlob';
import JSZip from 'jszip';
import guid from '@ohif/core/src/utils/guid';

const {requiredTags} = require('../../utils/requiredTags');

const DownloadForm = ({
  onClose,
  modalService,
  uiNotificationService,
  }) => {

    const { t } = useTranslation('Modals');

    const [progress, setProgress] = useState(0);
    const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
    const [progressText, setProgressText] = useState('preparing data');

   async function downloadStudy () {

    const studyUIDs = DicomMetadataStore.getStudyInstanceUIDs();

    console.log('download study');
    console.log('study uids:', studyUIDs);

    for (let studyNo = 0; studyNo < studyUIDs.length; studyNo++) {

      console.log('study no:', studyNo);
      const study = DicomMetadataStore.getStudy(studyUIDs[studyNo]);

      setShowLoadingIndicator(true);
      setProgressText(`preparing study no. ${studyNo+1} ...`);

      // https://stackoverflow.com/questions/42453683/how-to-reject-in-async-await-syntax
      try {
        await zipAll(study);
      } catch (error){
        console.log('zipAll error:', error);

      }
    };
    console.log('finished downloading all');
    onClose();
  };

  function zipAll (study) {
    console.log('zipall start', study);

    return new Promise(function (resolve, reject) {

    console.log('study before download:', study);

    const zip = new JSZip();

    study.series.forEach(serie => {
      if (['PD_FS', 'T2_FS', 'T2_STIR'].includes(serie.Weight[0]) && ['SAG', 'COR', 'AX'].includes(serie.Plane[0])){
        serie.instances.forEach(instance => {
          var meta_tags = {};
          var img_blob = new Blob([instance.PixelData[0]], {  // [0] Proxy miatt!! https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy
            type: 'application/dicom',
          });
          zip.file(`${instance.SOPInstanceUID}.dci`, img_blob);

          requiredTags.forEach(tag => {
            meta_tags[tag] = instance[tag];
          });

          var json = JSON.stringify(meta_tags); //Convert JSON Array to string.
          json = [json]; //Convert JSON string to BLOB.

          var tags_blob = new Blob(json, {type: 'text/plain;charset=utf-8'});

          zip.file(`${instance.SOPInstanceUID}.json`, tags_blob);
          foundImportant = true;

        });
      }
    });

    console.log('found important, zipping');
    zip.generateAsync({ type: 'blob' }, function updateCallback(metadata) {setProgress(Math.round(metadata.percent));
      }).then(function (blob){
        console.log('zip done, upload blob');
        setProgressText(`uploading study ...`);
        downloadBlob(blob).then(
          function () {
            DicomMetadataStore.updateInferenceInProgress(study.StudyInstanceUID, true);
            DicomMetadataStore.setProgressValue(study.StudyInstanceUID, undefined);
            DicomMetadataStore.updateProgressText(study.StudyInstanceUID, 'analysis progress:');
            console.log('resolve');
            resolve(1);
        });
      });
    });
  };

  useEffect(() => {
  }, [showLoadingIndicator]); //, progress, progressText]);
  // progress, progresstext nem kell, mert a komponens re-renderelődik, ha egy property változik
  // csak saját maga (UploadForm) rerendereléséhez kell useEffect

  console.log('upload form useEffect');

  const studyUIDs = DicomMetadataStore.getStudyInstanceUIDs();
  const study = DicomMetadataStore.getStudy(studyUIDs[0]);
  if (!study.inferable) {
    return (
      <div>
        <Typography variant="h6">
          {t(
            'Analysis not possible'
          )}
        </Typography>

        <div className="flex flex-col mt-6">
            <div>
              reason: {study.problems}
            </div>
        </div>
      </div>
    );
  }
  else{
    return (
      <div>
        <Typography variant="h6">
          {t(
            'Upload anonymized data to OrthoPred server'
          )}
        </Typography>

        <div className="flex flex-col mt-6">
            <div>
            {showLoadingIndicator && (
              <LoadingIndicatorProgress
                className="h-full w-full"
                textBlock={progressText}
                progress={progress}
                indicatorStyle={{width: '24em'}}/>
            )}
            </div>

        </div>
              <div className="w-1/2 mb-4">

                {/* <Input
                data-cy="file-name"
                value={presharedCode}
                onChange={evt => checkValue(evt.target.value)}
                label={t('Enter preshared code')}
              /> */}


              </div>
        <div className="mt-8">

        </div>

        {/* a gombok csak akkor aktívak, ha a LoadingIndicatorProgress nem !!! */}

        <div className="flex justify-end mt-4">
          <Button
            data-cy="cancel-btn"
            variant="outlined"
            size="initial"
            color="black"
            border="secondary"
            onClick={onClose}
            className="p-2"
          >
            {t('Cancel')}
          </Button>
          <Button
            className="ml-2"
            onClick={downloadStudy}
            color="primary"
            data-cy="download-btn"
          >
            {t('Upload')}
          </Button>
        </div>
      </div>
    );
  }
};

export default DownloadForm;
